<template>
  <ConfirmDialog
    v-model="dialogModel"
    title="Are you sure you want to edit this report?"
    cancel-text="Cancel"
    cancel-icon="mdi-cancel"
    confirm-text="Enable Editing"
    spread
    @cancel="close(false)"
    @confirm="enableEditing"
  >
    <h4>You are about to edit RAW DATA. Any changes made here cannot be reverted once saved. Please exercise caution when editing. Do you wish to continue?</h4>
  </ConfirmDialog>
</template>

<script>
import ConfirmDialog from "@/components/ConfirmDialog";

export default {
  components: { ConfirmDialog },
  props: {
    action: {
      type: Function,
      default: null
    },
    dialog: Boolean,
    close: {
      type: Function,
      default: null
    }
  },

  emits: ['update:dialog'],
  
  computed: {
    dialogModel: {
      get () { return this.dialog },
      set (value) { this.$emit('update:dialog', value) },
    },
  },

  methods: {
    async enableEditing() {
      await this.action();
      this.close(false);
    },
  },
};
</script>

<style scoped></style>
